import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@mui/material";
import ButtomCustom from "../../ButtonRound";
import { confirmAlert } from "react-confirm-alert"; // Import
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import parse from "html-react-parser";
import Typography from "@mui/material/Typography";
import HttpClient from "../../../helpers/HttpClient";
import { showToast } from "../../../utils/toast";
import OverlayLoader from "../../OverlayLoader";
import AlertModal from "../../Tests/components/AlertModal";
import NumberInput from "./components/BaseNumberInput";
import { useInterval } from "../../../hooks/useInterval";
import DigitalTimer from "./components/DigitalTimer";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Component from "./components/MaterialUIWordGrid";
import ResultadoLectura from "./components/ModalResult";

import DRAP_OCU_A from "./components/Exercises/DRAP_OCU_A";
import DRAP_OCU_B from "./components/Exercises/DRAP_OCU_B";
import DAMP_OCU_TRIANGULO from "./components/Exercises/DAMP_OCU_TRIANGULO";
import DAMP_VIS_BAR from "./components/Exercises/DAMP_VIS_BAR";
import DFIJ_TEX from "./components/Exercises/DFIJ_TEX";
import DAMP_VIS_CIR from "./components/Exercises/DAMP_VIS_CIR";
import DLOC_INF_DLOC_PAL_SIM from "./components/Exercises/DLOC_INF_DLOC_PAL_SIM";
import DAMP_OCU_RELOJ from "./components/Exercises/DAMP_OCU_RELOJ";
import DAMP_OCU_BLOQUES from "./components/Exercises/DAMP_OCU_BLOQUES";
import DFIJ_BLO from "./components/Exercises/DFIJ_BLO";
import DMED_LET from "./components/Exercises/DMED_LET";
import DLET_DIF from "./components/Exercises/DLET_DIF";
import DVEL_PAL from "./components/Exercises/DVEL_PAL";

const ExerciseContainerSR = ({
  courseCode,
  data,
  haveContainer = false,
  onFinalize,
  onContinue,
  numQuestionsForUse = 0,
  configPercentage,
  setResultForContainer,
  containerStepExcersiseType,
}) => {
  const [openLoader, setOpenOpenLoader] = useState(false);
  const authState = useSelector((state) => state.auth);
  const userId = authState && authState.user ? authState.user.email : "test";
  const [explanation, setExplanation] = useState({ show: false });
  const [count, setCount] = useState(1000);
  const [delay, setDelay] = useState(1000);
  const [isRunning, setIsRunning] = useState(false);
  const [exerciseData, setExerciseData] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [velocity, setVelocity] = useState(0);
  const [allData, setAllData] = useState(null);
  const additionalDataRef = useRef(null)

  const loadData = async () => {
    setOpenOpenLoader(true);
    const url = `/speed-reading/exercise-data/${userId}/${courseCode}/LECTURA/${data.id}`;
    const request = await HttpClient().get(url);

    setOpenOpenLoader(false);
    if (request.error) {
      showToast("No se pudo cargar información. Intenta nuevamente.", "error");
      return;
    }
    console.log(request.data);
    setAllData(request.data);
    setExerciseData(request.data.data);
    setExplanation(Object.assign({ show: true }, request.data.explanation));
  };

  const updateAdditionalData = (data) => {
    additionalDataRef.current = data
  };

  const saveExersice = async () => {
    let requestObject = {
      meta: {
        velocity: velocity,
      },
    };
    if (additionalDataRef.current) {
      let currentMeta = {
        ...requestObject.meta,
      };
      currentMeta = Object.assign(currentMeta, additionalDataRef.current);
      requestObject.meta = currentMeta;
    }
    
    await HttpClient().post(`/lessons/save-sublesson/${userId}/${data.id}`, requestObject)
    
    onFinalize();
    setShowResult(true);
    setIsRunning(false)
  };
  useEffect(() => {
    if (data) {
      setOpenOpenLoader(true);
      loadData();
      document.getElementsByClassName("main")[0].scrollTo({ top: 0, left: 0 });
    }
  }, []);

  useEffect(() => {
    if (allData) {
      let velocityTemp = 0

      if (!allData.lastExerciseVelocity && !allData.lastTestVelocity){
        velocityTemp = 200;
      }else if (!allData.lastExerciseVelocity && allData.lastTestVelocity){
        const currentVelocity = parseInt(allData.lastTestVelocity.velocity) 
        velocityTemp = Math.ceil(currentVelocity  + parseInt((currentVelocity * allData.incrementPercentVelocity) / 100)); 
      }else if (allData.lastExerciseVelocity && !allData.lastTestVelocity){
        velocityTemp = parseInt(allData.lastExerciseVelocity.velocity)
      }else if (allData.lastExerciseVelocity && allData.lastTestVelocity){
          if (new Date(allData.lastTestVelocity.date).getTime() >= new Date(allData.lastExerciseVelocity.date).getTime() ){
            const currentVelocity = parseInt(allData.lastTestVelocity.velocity)
            velocityTemp = Math.ceil(currentVelocity  + parseInt((currentVelocity * allData.incrementPercentVelocity) / 100)); 
          }else{
            velocityTemp = parseInt(allData.lastExerciseVelocity.velocity)
          }
      }

      setVelocity(velocityTemp);
      
    }
  }, [allData]);

  return (
    <Grid
      container
      columns={{ xs: 4, md: 12 }}
      sx={{
        maxWidth: "900px",
        margin: "auto",
        height: "auto",
        mt: 1,
        backgroundColor: "#fff",
        alignContent: "center",
        //border: "1px solid green",
        //padding: "10px 10px 10px 10px",
      }}
    >
      <OverlayLoader open={openLoader} />
      <Grid container  display="flex" flexDirection="row">
        {exerciseData && isRunning ? (
          <>
            <DigitalTimer
              maxTime={exerciseData.tiempo * 60}
              //maxTime={10}
              isRunning={isRunning}
              onFinish={saveExersice}
              key={"click_"+exerciseData.id}
              align="center"
            />

            {exerciseData.tipo_ejercicio == "DRAP_OCU_A" ? (
              <DRAP_OCU_A
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
              />
            ) : null}
            {exerciseData.tipo_ejercicio == "DLET_DIF" ? (
              <DLET_DIF
                isRunning={isRunning}
                onAdditionalData={updateAdditionalData}
              />
            ) : null}
            {exerciseData.tipo_ejercicio == "DRAP_OCU_B" ? (
              <DRAP_OCU_B
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
              />
            ) : null}
            {exerciseData.tipo_ejercicio == "DAMP_OCU_TRIANGULO" ? (
              <DAMP_OCU_TRIANGULO
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
              />
            ) : null}
            {exerciseData.tipo_ejercicio == "DAMP_VIS_BAR" ? (
              <DAMP_VIS_BAR
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
              />
            ) : null}
            {exerciseData.tipo_ejercicio == "DFIJ_TEX" ? (
              <DFIJ_TEX
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
              />
            ) : null}
            {exerciseData.tipo_ejercicio == "DAMP_VIS_CIR" ? (
              <DAMP_VIS_CIR
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
              />
            ) : null}

            {exerciseData.tipo_ejercicio == "DAMP_OCU_BLOQUES" ? (
              <DAMP_OCU_BLOQUES
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
              />
            ) : null}

            {exerciseData.tipo_ejercicio == "DFIJ_BLO" ? (
              <DFIJ_BLO
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
              />
            ) : null}
            {exerciseData.tipo_ejercicio == "DMED_LET" ? (
              <DMED_LET
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
              />
            ) : null}
            {["DLOC_INF", "DLOC_PAL_SIM"].includes(
              exerciseData.tipo_ejercicio
            ) ? (
              <DLOC_INF_DLOC_PAL_SIM
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
                isSIM={exerciseData.tipo_ejercicio == "DLOC_PAL_SIM"}
                onAdditionalData={updateAdditionalData}
              />
            ) : null}
            {exerciseData.tipo_ejercicio == "DAMP_OCU_RELOJ" ? (
              <DAMP_OCU_RELOJ
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
              />
            ) : null}
            {exerciseData.tipo_ejercicio == "DVEL_PAL" ? (
              <DVEL_PAL
                exercise={exerciseData}
                isRunning={isRunning}
                velocity={velocity}
                onAdditionalData={updateAdditionalData}
              />
            ) : null}
          </>
        ) : null}
      </Grid>
      <AlertModal
        open={explanation.show}
        title={
          explanation.titulo
            ? parse(`<strong>${explanation?.titulo}</strong>`)
            : ""
        }
        content={
          <>
            {explanation.explicacion ? parse(explanation?.explicacion) : ""}
            {allData?.lastTestVelocity ? (
              <Typography
                component="div"
                variant="h6"
                fontSize={16}
                sx={{ textAlign: "center" }}
              >
                {`Velocidad del último test: ${allData.lastTestVelocity.velocity}`}
              </Typography>
            ) : null}
            {allData?.lastExerciseVelocity ? (
              <Typography
                component="div"
                variant="h6"
                fontSize={16}
                sx={{ textAlign: "center" }}
              >
                {`Velocidad del último ejercicio: ${allData.lastExerciseVelocity.velocity}`}
              </Typography>
            ) : null}

            <Typography
              component="div"
              variant="h6"
              sx={{ textAlign: "center" }}
            >
              {"Velocidad recomendada"}
            </Typography>
            <NumberInput
              placeholder="Velocidad"
              step={10}
              value={velocity}
              min={0}
              max={100000000}
              onChange={(event, val) => setVelocity(val)}
            />
          </>
        }
        buttonText={"Iniciar"}
        onButtonClick={() => {
          setExplanation({ ...explanation, show: false });
          setIsRunning(true);
        }}
        secondButtonText={"Salir"}
        onSecondButtonClick={() => {
          setExplanation({ ...explanation, show: false });
        }}
      />

      <AlertModal
        open={showResult}
        content={
          <>
            <ResultadoLectura
              tiempoTotal={exerciseData?.tiempo}
              velocidadLectura={velocity}
            />
          </>
        }
        buttonText={"Aceptar"}
        onButtonClick={() => {
          onContinue();
        }}
      />
    </Grid>
  );
};

export default ExerciseContainerSR;
